import { render, staticRenderFns } from "./BarChartFlightNumbers.vue?vue&type=template&id=2d0e66e1&scoped=true&"
import script from "./BarChartFlightNumbers.vue?vue&type=script&lang=js&"
export * from "./BarChartFlightNumbers.vue?vue&type=script&lang=js&"
import style0 from "./BarChartFlightNumbers.vue?vue&type=style&index=0&id=2d0e66e1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0e66e1",
  null
  
)

export default component.exports